import React from "react";
import { useNavigate } from "react-router-dom";
import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";

const BlogBanner = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full">
            {/* Breadcrumb Section */}
            <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
                <img
                    src={HomeIcon}
                    alt="HomeIcon"
                    className="cursor-pointer"
                    onClick={() => navigate("/")}
                />
                <div className="flex items-center mx-[5px]">
                    <img src={RightSideArrow} alt="RightSideArrow" />
                    <img src={RightSideArrow} alt="RightSideArrow" />
                </div>
                <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">
                    Blog
                </div>
            </div>

            {/* Banner Section - Matches NZGallery style with background showing through */}
            <div className="w-full bg-fixed bg-cover bg-center relative">
                <div className="w-full flex items-center justify-center">
                    <div
                        className="text-white kuunari-bold 
                        text-[40px] 
                        md:text-[80px] 
                        lg:text-[120px] py-[40px] md:py-[68px] max-w-[1127px] text-center"
                        style={{
                            textShadow: "2px 4px 6px #000000",
                        }}
                    >
                        Blog
                    </div>
                </div>
                <img src={CardUpImg} className="w-full" alt="banner-edge" />
            </div>
        </div>
    );
};

export default BlogBanner;
